[
  ".com",
  ".org",
  ".net",
  ".int",
  ".edu",
  ".gov",
  ".mil",
  ".arpa",
  ".ac",
  ".ad",
  ".ae",
  ".af",
  ".ag",
  ".ai",
  ".al",
  ".am",
  ".an",
  ".ao",
  ".aq",
  ".ar",
  ".as",
  ".at",
  ".au",
  ".aw",
  ".ax",
  ".az",
  ".ba",
  ".bb",
  ".bd",
  ".be",
  ".bf",
  ".bg",
  ".bh",
  ".bi",
  ".bj",
  ".bl",
  ".bm",
  ".bn",
  ".bo",
  ".bq",
  ".br",
  ".bs",
  ".bt",
  ".bv",
  ".bw",
  ".by",
  ".bz",
  ".ca",
  ".cc",
  ".cd",
  ".cf",
  ".cg",
  ".ch",
  ".ci",
  ".ck",
  ".cl",
  ".cm",
  ".cn",
  ".co",
  ".cr",
  ".cu",
  ".cv",
  ".cw",
  ".cx",
  ".cy",
  ".cz",
  ".de",
  ".dj",
  ".dk",
  ".dm",
  ".do",
  ".dz",
  ".ec",
  ".ee",
  ".eg",
  ".eh",
  ".er",
  ".es",
  ".et",
  ".eu",
  ".fi",
  ".fj",
  ".fk",
  ".fm",
  ".fo",
  ".fr",
  ".ga",
  ".gb",
  ".gd",
  ".ge",
  ".gf",
  ".gg",
  ".gh",
  ".gi",
  ".gl",
  ".gm",
  ".gn",
  ".gp",
  ".gq",
  ".gr",
  ".gs",
  ".gt",
  ".gu",
  ".gw",
  ".gy",
  ".hk",
  ".hm",
  ".hn",
  ".hr",
  ".ht",
  ".hu",
  ".id",
  ".ie",
  ".il",
  ".im",
  ".in",
  ".io",
  ".iq",
  ".ir",
  ".is",
  ".it",
  ".je",
  ".jm",
  ".jo",
  ".jp",
  ".ke",
  ".kg",
  ".kh",
  ".ki",
  ".km",
  ".kn",
  ".kp",
  ".kr",
  ".kw",
  ".ky",
  ".kz",
  ".la",
  ".lb",
  ".lc",
  ".li",
  ".lk",
  ".lr",
  ".ls",
  ".lt",
  ".lu",
  ".lv",
  ".ly",
  ".ma",
  ".mc",
  ".md",
  ".me",
  ".mf",
  ".mg",
  ".mh",
  ".mk",
  ".ml",
  ".mm",
  ".mn",
  ".mo",
  ".mp",
  ".mq",
  ".mr",
  ".ms",
  ".mt",
  ".mu",
  ".mv",
  ".mw",
  ".mx",
  ".my",
  ".mz",
  ".na",
  ".nc",
  ".ne",
  ".nf",
  ".ng",
  ".ni",
  ".nl",
  ".no",
  ".np",
  ".nr",
  ".nu",
  ".nz",
  ".om",
  ".pa",
  ".pe",
  ".pf",
  ".pg",
  ".ph",
  ".pk",
  ".pl",
  ".pm",
  ".pn",
  ".pr",
  ".ps",
  ".pt",
  ".pw",
  ".py",
  ".qa",
  ".re",
  ".ro",
  ".rs",
  ".ru",
  ".rw",
  ".sa",
  ".sb",
  ".sc",
  ".sd",
  ".se",
  ".sg",
  ".sh",
  ".si",
  ".sj",
  ".sk",
  ".sl",
  ".sm",
  ".sn",
  ".so",
  ".sr",
  ".ss",
  ".st",
  ".su",
  ".sv",
  ".sx",
  ".sy",
  ".sz",
  ".tc",
  ".td",
  ".tf",
  ".tg",
  ".th",
  ".tj",
  ".tk",
  ".tl",
  ".tm",
  ".tn",
  ".to",
  ".tp",
  ".tr",
  ".tt",
  ".tv",
  ".tw",
  ".tz",
  ".ua",
  ".ug",
  ".uk",
  ".um",
  ".us",
  ".uy",
  ".uz",
  ".va",
  ".vc",
  ".ve",
  ".vg",
  ".vi",
  ".vn",
  ".vu",
  ".wf",
  ".ws",
  ".ye",
  ".yt",
  ".za",
  ".zm",
  ".zw",
  ".\u0570\u0561\u0575",
  ".\u09ac\u09be\u0982\u09b2\u09be",
  ".\u0431\u0435\u043b",
  ".\u0431\u0433",
  ".\u4e2d\u56fd",
  ".\u4e2d\u570b",
  ".\u0435\u044e",
  ".\u10d2\u10d4",
  ".\u03b5\u03bb",
  ".\u9999\u6e2f",
  ".\u092d\u093e\u0930\u0924",
  ".\u0c2d\u0c3e\u0c30\u0c24\u0c4d",
  ".\u0aad\u0abe\u0ab0\u0aa4",
  ".\u0a2d\u0a3e\u0a30\u0a24",
  ".\u0b87\u0ba8\u0bcd\u0ba4\u0bbf\u0baf\u0bbe",
  ".\u09ad\u09be\u09b0\u09a4",
  ".\u0cad\u0cbe\u0cb0\u0ca4",
  ".\u0d2d\u0d3e\u0d30\u0d24\u0d02",
  ".\u09ad\u09be\u09f0\u09a4",
  ".\u0b2d\u0b3e\u0b30\u0b24",
  ".\u092d\u093e\u0930\u0924\u092e\u094d",
  ".\u092d\u093e\u0930\u094b\u0924",
  ".\u049b\u0430\u0437",
  ".\u6fb3\u95e8",
  ".\u6fb3\u9580",
  ".\u043c\u043a\u0434",
  ".\u043c\u043e\u043d",
  ".\u0440\u0444",
  ".\u0441\u0440\u0431",
  ".\u65b0\u52a0\u5761",
  ".\u0b9a\u0bbf\u0b99\u0bcd\u0b95\u0baa\u0bcd\u0baa\u0bc2\u0bb0\u0bcd",
  ".\ud55c\uad6d",
  ".\u0dbd\u0d82\u0d9a\u0dcf",
  ".\u0b87\u0bb2\u0b99\u0bcd\u0b95\u0bc8",
  ".\u53f0\u6e7e",
  ".\u53f0\u7063",
  ".\u0e44\u0e17\u0e22",
  ".\u0443\u043a\u0440",
  ".abc",
  ".academy",
  ".accountant",
  ".accountants",
  ".active",
  ".actor",
  ".ads",
  ".adult",
  ".aero",
  ".agency",
  ".airforce",
  ".analytics",
  ".apartments",
  ".app",
  ".archi",
  ".army",
  ".art",
  ".associates",
  ".attorney",
  ".auction",
  ".audible",
  ".audio",
  ".author",
  ".auto",
  ".autos",
  ".aws",
  ".baby",
  ".bananarepublic",
  ".band",
  ".bank",
  ".bar",
  ".barefoot",
  ".bargains",
  ".baseball",
  ".basketball",
  ".beauty",
  ".beer",
  ".best",
  ".bestbuy",
  ".bet",
  ".bible",
  ".bid",
  ".bike",
  ".bingo",
  ".bio",
  ".biz",
  ".black",
  ".blackfriday",
  ".blockbuster",
  ".blog",
  ".blue",
  ".boo",
  ".book",
  ".boots",
  ".bot",
  ".boutique",
  ".box",
  ".broadway",
  ".broker",
  ".build",
  ".builders",
  ".business",
  ".buy",
  ".buzz",
  ".cab",
  ".cafe",
  ".call",
  ".cam",
  ".camera",
  ".camp",
  ".cancerresearch",
  ".capital",
  ".car",
  ".cards",
  ".care",
  ".career",
  ".careers",
  ".cars",
  ".case",
  ".cash",
  ".casino",
  ".catering",
  ".catholic",
  ".center",
  ".ceo",
  ".cfd",
  ".channel",
  ".chat",
  ".cheap",
  ".christmas",
  ".church",
  ".cipriani",
  ".circle",
  ".city",
  ".claims",
  ".cleaning",
  ".click",
  ".clinic",
  ".clothing",
  ".cloud",
  ".club",
  ".coach",
  ".codes",
  ".coffee",
  ".college",
  ".community",
  ".company",
  ".compare",
  ".computer",
  ".condos",
  ".construction",
  ".consulting",
  ".contact",
  ".contractors",
  ".cooking",
  ".cool",
  ".coop",
  ".country",
  ".coupon",
  ".coupons",
  ".courses",
  ".credit",
  ".creditcard",
  ".cruise",
  ".cricket",
  ".cruises",
  ".dad",
  ".dance",
  ".data",
  ".date",
  ".dating",
  ".day",
  ".deal",
  ".deals",
  ".degree",
  ".delivery",
  ".democrat",
  ".dental",
  ".dentist",
  ".design",
  ".dev",
  ".diamonds",
  ".diet",
  ".digital",
  ".direct",
  ".directory",
  ".discount",
  ".diy",
  ".docs",
  ".doctor",
  ".dog",
  ".domains",
  ".dot",
  ".download",
  ".drive",
  ".duck",
  ".earth",
  ".eat",
  ".eco",
  ".education",
  ".email",
  ".energy",
  ".engineer",
  ".engineering",
  ".enterprises",
  ".equipment",
  ".esq",
  ".estate",
  ".events",
  ".exchange",
  ".expert",
  ".exposed",
  ".express",
  ".fail",
  ".faith",
  ".family",
  ".fan",
  ".fans",
  ".farm",
  ".fashion",
  ".fast",
  ".feedback",
  ".film",
  ".final",
  ".finance",
  ".financial",
  ".fire",
  ".fish",
  ".fishing",
  ".fit",
  ".fitness",
  ".flights",
  ".florist",
  ".flowers",
  ".fly",
  ".foo",
  ".food",
  ".foodnetwork",
  ".football",
  ".forsale",
  ".forum",
  ".foundation",
  ".free",
  ".frontdoor",
  ".fun",
  ".fund",
  ".furniture",
  ".fyi",
  ".gallery",
  ".game",
  ".games",
  ".garden",
  ".gift",
  ".gifts",
  ".gives",
  ".glass",
  ".global",
  ".gold",
  ".golf",
  ".gop",
  ".graphics",
  ".green",
  ".gripe",
  ".grocery",
  ".group",
  ".guide",
  ".guitars",
  ".guru",
  ".hair",
  ".hangout",
  ".health",
  ".healthcare",
  ".help",
  ".here",
  ".hiphop",
  ".hiv",
  ".hockey",
  ".holdings",
  ".holiday",
  ".homegoods",
  ".homes",
  ".homesense",
  ".horse",
  ".hospital",
  ".host",
  ".hosting",
  ".hot",
  ".hotels",
  ".house",
  ".how",
  ".ice",
  ".industries",
  ".info",
  ".ing",
  ".ink",
  ".institute",
  ".insurance",
  ".insure",
  ".international",
  ".investments",
  ".jewelry",
  ".jobs",
  ".joy",
  ".kim",
  ".kitchen",
  ".land",
  ".latino",
  ".law",
  ".lawyer",
  ".lease",
  ".legal",
  ".lgbt",
  ".life",
  ".lifeinsurance",
  ".lighting",
  ".like",
  ".limited",
  ".limo",
  ".link",
  ".live",
  ".living",
  ".loan",
  ".loans",
  ".locker",
  ".lol",
  ".lotto",
  ".love",
  ".luxury",
  ".makeup",
  ".management",
  ".map",
  ".market",
  ".marketing",
  ".markets",
  ".mba",
  ".med",
  ".media",
  ".meet",
  ".meme",
  ".memorial",
  ".men",
  ".menu",
  ".mint",
  ".mobi",
  ".mobile",
  ".mobily",
  ".moe",
  ".mom",
  ".money",
  ".mortgage",
  ".motorcycles",
  ".mov",
  ".movie",
  ".museum",
  ".name",
  ".navy",
  ".network",
  ".new",
  ".news",
  ".ngo",
  ".ninja",
  ".now",
  ".observer",
  ".off",
  ".one",
  ".ong",
  ".onl",
  ".online",
  ".ooo",
  ".open",
  ".organic",
  ".origins",
  ".page",
  ".partners",
  ".parts",
  ".party",
  ".pay",
  ".pet",
  ".pharmacy",
  ".phone",
  ".photo",
  ".photography",
  ".photos",
  ".physio",
  ".pics",
  ".pictures",
  ".pid",
  ".pin",
  ".pink",
  ".pizza",
  ".place",
  ".plumbing",
  ".plus",
  ".poker",
  ".porn",
  ".post",
  ".press",
  ".prime",
  ".pro",
  ".productions",
  ".prof",
  ".promo",
  ".properties",
  ".property",
  ".protection",
  ".pub",
  ".qpon",
  ".racing",
  ".radio",
  ".read",
  ".realestate",
  ".realtor",
  ".realty",
  ".recipes",
  ".red",
  ".rehab",
  ".reit",
  ".ren",
  ".rent",
  ".rentals",
  ".repair",
  ".report",
  ".republican",
  ".rest",
  ".restaurant",
  ".review",
  ".reviews",
  ".rich",
  ".rip",
  ".rocks",
  ".rodeo",
  ".room",
  ".rugby",
  ".run",
  ".safe",
  ".sale",
  ".save",
  ".scholarships",
  ".school",
  ".science",
  ".search",
  ".secure",
  ".security",
  ".select",
  ".services",
  ".sex",
  ".sexy",
  ".shoes",
  ".shop",
  ".shopping",
  ".show",
  ".showtime",
  ".silk",
  ".singles",
  ".site",
  ".ski",
  ".skin",
  ".sky",
  ".sling",
  ".smile",
  ".soccer",
  ".social",
  ".software",
  ".solar",
  ".solutions",
  ".song",
  ".space",
  ".spot",
  ".spreadbetting",
  ".storage",
  ".store",
  ".stream",
  ".studio",
  ".study",
  ".style",
  ".sucks",
  ".supplies",
  ".supply",
  ".support",
  ".surf",
  ".surgery",
  ".systems",
  ".talk",
  ".tattoo",
  ".tax",
  ".taxi",
  ".team",
  ".tech",
  ".technology",
  ".tel",
  ".tennis",
  ".theater",
  ".theatre",
  ".tickets",
  ".tips",
  ".tires",
  ".today",
  ".tools",
  ".top",
  ".tours",
  ".town",
  ".toys",
  ".trade",
  ".trading",
  ".training",
  ".travel",
  ".travelersinsurance",
  ".trust",
  ".tube",
  ".tunes",
  ".uconnect",
  ".university",
  ".vacations",
  ".ventures",
  ".vet",
  ".video",
  ".villas",
  ".vip",
  ".vision",
  ".vodka",
  ".vote",
  ".voting",
  ".voyage",
  ".wang",
  ".watch",
  ".watches",
  ".weather",
  ".webcam",
  ".website",
  ".wed",
  ".wedding",
  ".whoswho",
  ".wiki",
  ".win",
  ".wine",
  ".winners",
  ".work",
  ".works",
  ".world",
  ".wow",
  ".wtf",
  ".xxx",
  ".xyz",
  ".yachts",
  ".yoga",
  ".you",
  ".zero",
  ".zone",
  ".shouji",
  ".tushu",
  ".wanggou",
  ".weibo",
  ".xihuan",
  ".arte",
  ".clinique",
  ".luxe",
  ".maison",
  ".moi",
  ".rsvp",
  ".sarl",
  ".epost",
  ".gmbh",
  ".haus",
  ".immobilien",
  ".jetzt",
  ".kaufen",
  ".kinder",
  ".reise",
  ".reisen",
  ".schule",
  ".versicherung",
  ".desi",
  ".shiksha",
  ".casa",
  ".immo",
  ".moda",
  ".voto",
  ".bom",
  ".passagens",
  ".abogado",
  ".gratis",
  ".futbol",
  ".hoteles",
  ".juegos",
  ".ltda",
  ".soy",
  ".tienda",
  ".uno",
  ".viajes",
  ".vuelos",
  ".\u0643\u0648\u0645",
  ".\u0645\u0648\u0628\u0627\u064a\u0644\u064a",
  ".\u0643\u0627\u062b\u0648\u0644\u064a\u0643",
  ".\u0628\u064a\u062a\u0643",
  ".\u5728\u7ebf",
  ".\u4e2d\u6587\u7f51",
  ".\u79fb\u52a8",
  ".\u7f51\u5740",
  ".\u7f51\u7edc",
  ".\u516c\u53f8",
  ".\u5546\u57ce",
  ".\u673a\u6784",
  ".\u6211\u7231\u4f60",
  ".\u5546\u6807",
  ".\u4e16\u754c",
  ".\u96c6\u56e2",
  ".\u0434\u0435\u0442\u0438",
  ".\u043a\u0430\u0442\u043e\u043b\u0438\u043a",
  ".\u043a\u043e\u043c",
  ".\u043e\u043d\u043b\u0430\u0439\u043d",
  ".\u043e\u0440\u0433",
  ".\u0441\u0430\u0439\u0442",
  ".\u0938\u0902\u0917\u0920\u0928",
  ".\u0915\u0949\u092e",
  ".\u0928\u0947\u091f",
  ".\ub2f7\ucef4",
  ".\ub2f7\ub137",
  ".\u05e7\u05d5\u05dd",
  ".\u307f\u3093\u306a",
  ".\u30bb\u30fc\u30eb",
  ".\u30d5\u30a1\u30c3\u30b7\u30e7\u30f3",
  ".\u30b9\u30c8\u30a2",
  ".\u30dd\u30a4\u30f3\u30c8",
  ".\u30af\u30e9\u30a6\u30c9",
  ".\u30b3\u30e0",
  ".\u0e04\u0e2d\u0e21",
  ".africa",
  ".capetown",
  ".durban",
  ".joburg",
  ".abudhabi",
  ".arab",
  ".asia",
  ".doha",
  ".dubai",
  ".krd",
  ".kyoto",
  ".nagoya",
  ".okinawa",
  ".osaka",
  ".ryukyu",
  ".taipei",
  ".tatar",
  ".tokyo",
  ".yokohama",
  ".alsace",
  ".amsterdam",
  ".bcn",
  ".barcelona",
  ".bayern",
  ".berlin",
  ".brussels",
  ".budapest",
  ".bzh",
  ".cat",
  ".cologne",
  ".corsica",
  ".cymru",
  ".eus",
  ".frl",
  ".gal",
  ".gent",
  ".hamburg",
  ".helsinki",
  ".irish",
  ".ist",
  ".istanbul",
  ".koeln",
  ".london",
  ".madrid",
  ".moscow",
  ".nrw",
  ".paris",
  ".ruhr",
  ".saarland",
  ".scot",
  ".stockholm",
  ".swiss",
  ".tirol",
  ".vlaanderen",
  ".wales",
  ".wien",
  ".zuerich",
  ".boston",
  ".miami",
  ".nyc",
  ".quebec",
  ".vegas",
  ".kiwi",
  ".melbourne",
  ".sydney",
  ".lat",
  ".rio",
  ".\u4f5b\u5c71",
  ".\u5e7f\u4e1c",
  ".\u043c\u043e\u0441\u043a\u0432\u0430",
  ".moscow",
  ".\u0440\u0443\u0441",
  ".\u0627\u0628\u0648\u0638\u0628\u064a",
  ".aaa",
  ".aarp",
  ".abarth",
  ".abb",
  ".abbott",
  ".abbvie",
  ".accenture",
  ".aco",
  ".aeg",
  ".aetna",
  ".afl",
  ".agakhan",
  ".aig",
  ".aigo",
  ".airbus",
  ".airtel",
  ".akdn",
  ".alfaromeo",
  ".alibaba",
  ".alipay",
  ".allfinanz",
  ".allstate",
  ".ally",
  ".alstom",
  ".americanexpress",
  ".amex",
  ".amica",
  ".android",
  ".anz",
  ".aol",
  ".apple",
  ".aquarelle",
  ".aramco",
  ".audi",
  ".auspost",
  ".axa",
  ".azure",
  ".baidu",
  ".barclaycard",
  ".barclays",
  ".bauhaus",
  ".bbc",
  ".bbt",
  ".bbva",
  ".bcg",
  ".bentley",
  ".bharti",
  ".bing",
  ".blanco",
  ".bloomberg",
  ".bms",
  ".bmw",
  ".bnl",
  ".bnpparibas",
  ".boehringer",
  ".bond",
  ".booking",
  ".bosch",
  ".bostik",
  ".bradesco",
  ".bridgestone",
  ".brother",
  ".bugatti",
  ".cal",
  ".calvinklein",
  ".canon",
  ".capitalone",
  ".caravan",
  ".cartier",
  ".cba",
  ".cbn",
  ".cbre",
  ".cbs",
  ".cern",
  ".cfa",
  ".chanel",
  ".chase",
  ".chintai",
  ".chrome",
  ".chrysler",
  ".cisco",
  ".citadel",
  ".citi",
  ".citic",
  ".clubmed",
  ".comcast",
  ".commbank",
  ".creditunion",
  ".crown",
  ".crs",
  ".cuisinella",
  ".dabur",
  ".datsun",
  ".dealer",
  ".dell",
  ".deloitte",
  ".delta",
  ".dhl",
  ".discover",
  ".dish",
  ".dnp",
  ".dodge",
  ".dunlop",
  ".dupont",
  ".dvag",
  ".edeka",
  ".emerck",
  ".epson",
  ".ericsson",
  ".erni",
  ".esurance",
  ".etisalat",
  ".eurovision",
  ".everbank",
  ".extraspace",
  ".fage",
  ".fairwinds",
  ".farmers",
  ".FedEx",
  ".ferrari",
  ".ferrero",
  ".fiat",
  ".fidelity",
  ".firestone",
  ".firmdale",
  ".flickr",
  ".flir",
  ".flsmidth",
  ".ford",
  ".fox",
  ".fresenius",
  ".forex",
  ".frogans",
  ".frontier",
  ".fujitsu",
  ".fujixerox",
  ".gallo",
  ".gallup",
  ".gap",
  ".gbiz",
  ".gea",
  ".genting",
  ".giving",
  ".gle",
  ".globo",
  ".gmail",
  ".gmo",
  ".gmx",
  ".godaddy",
  ".goldpoint",
  ".goodyear",
  ".google",
  ".grainger",
  ".guardian",
  ".gucci",
  ".hbo",
  ".hdfc",
  ".hdfcbank",
  ".hermes",
  ".hisamitsu",
  ".hitachi",
  ".hkt",
  ".honda",
  ".honeywell",
  ".hotmail",
  ".hsbc",
  ".htc",
  ".hughes",
  ".hyatt",
  ".hyundai",
  ".ibm",
  ".ieee",
  ".ifm",
  ".ikano",
  ".imdb",
  ".infiniti",
  ".intel",
  ".intuit",
  ".ipiranga",
  ".iselect",
  ".itau",
  ".itv",
  ".iveco",
  ".jaguar",
  ".java",
  ".jcb",
  ".jcp",
  ".jeep",
  ".jpmorgan",
  ".juniper",
  ".kddi",
  ".kerryhotels",
  ".kerrylogistics",
  ".kerryproperties",
  ".kfh",
  ".kia",
  ".kindle",
  ".komatsu",
  ".kpmg",
  ".kred",
  ".kuokgroup",
  ".lacaixa",
  ".ladbrokes",
  ".lamborghini",
  ".lancaster",
  ".lancia",
  ".lancome",
  ".landrover",
  ".lanxess",
  ".lasalle",
  ".latrobe",
  ".lds",
  ".lego",
  ".liaison",
  ".lexus",
  ".lidl",
  ".lifestyle",
  ".lilly",
  ".lincoln",
  ".linde",
  ".lipsy",
  ".lixil",
  ".locus",
  ".lotte",
  ".lpl",
  ".lplfinancial",
  ".lundbeck",
  ".lupin",
  ".macys",
  ".maif",
  ".man",
  ".mango",
  ".marriott",
  ".maserati",
  ".mattel",
  ".mcd",
  ".mcdonalds",
  ".mckinsey",
  ".meo",
  ".metlife",
  ".microsoft",
  ".mini",
  ".mit",
  ".mitsubishi",
  ".mlb",
  ".mma",
  ".monash",
  ".mormon",
  ".moto",
  ".movistar",
  ".msd",
  ".mtn",
  ".mtpc",
  ".mtr",
  ".mutual",
  ".mutuelle",
  ".nadex",
  ".nationwide",
  ".natura",
  ".nba",
  ".nec",
  ".netflix",
  ".neustar",
  ".newholland",
  ".nexus",
  ".nfl",
  ".nhk",
  ".nico",
  ".nike",
  ".nikon",
  ".nissan",
  ".nissay",
  ".nokia",
  ".northwesternmutual",
  ".norton",
  ".nra",
  ".ntt",
  ".obi",
  ".office",
  ".omega",
  ".oracle",
  ".orange",
  ".orientexpress",
  ".otsuka",
  ".ovh",
  ".pamperedchef",
  ".panasonic",
  ".pccw",
  ".pfizer",
  ".philips",
  ".piaget",
  ".pictet",
  ".ping",
  ".pioneer",
  ".play",
  ".playstation",
  ".pohl",
  ".politie",
  ".praxi",
  ".prod",
  ".progressive",
  ".pru",
  ".prudential",
  ".pwc",
  ".quest",
  ".qvc",
  ".redstone",
  ".reliance",
  ".rexroth",
  ".ricoh",
  ".rmit",
  ".rocher",
  ".rogers",
  ".rwe",
  ".safety",
  ".sakura",
  ".samsung",
  ".sandvik",
  ".sandvikcoromant",
  ".sanofi",
  ".sap",
  ".saxo",
  ".sbi",
  ".sbs",
  ".sca",
  ".scb",
  ".schaeffler",
  ".schmidt",
  ".schwarz",
  ".scjohnson",
  ".scor",
  ".seat",
  ".sener",
  ".ses",
  ".sew",
  ".seven",
  ".sfr",
  ".seek",
  ".shangrila",
  ".sharp",
  ".shaw",
  ".shell",
  ".shriram",
  ".sina",
  ".skype",
  ".smart",
  ".sncf",
  ".softbank",
  ".sohu",
  ".Sony",
  ".spiegel",
  ".stada",
  ".staples",
  ".star",
  ".starhub",
  ".statebank",
  ".statefarm",
  ".statoil",
  ".stc",
  ".stcgroup",
  ".suzuki",
  ".swatch",
  ".swiftcover",
  ".symantec",
  ".taobao",
  ".target",
  ".tatamotors",
  ".tdk",
  ".telecity",
  ".telefonica",
  ".temasek",
  ".teva",
  ".tiffany",
  ".tjx",
  ".toray",
  ".toshiba",
  ".total",
  ".toyota",
  ".travelchannel",
  ".travelers",
  ".tui",
  ".tvs",
  ".ubs",
  ".unicom",
  ".uol",
  ".ups",
  ".vanguard",
  ".verisign",
  ".vig",
  ".viking",
  ".virgin",
  ".visa",
  ".vista",
  ".vistaprint",
  ".vivo",
  ".volkswagen",
  ".volvo",
  ".walmart",
  ".walter",
  ".weatherchannel",
  ".weber",
  ".weir",
  ".williamhill",
  ".windows",
  ".wme",
  ".wolterskluwer",
  ".woodside",
  ".wtc",
  ".xbox",
  ".xerox",
  ".xfinity",
  ".xperia",
  ".yahoo",
  ".yamaxun",
  ".yandex",
  ".yodobashi",
  ".youtube",
  ".zappos",
  ".zara",
  ".zip",
  ".zippo",
  ".\u0627\u0631\u0627\u0645\u0643\u0648",
  ".\u8054\u901a",
  ".\u4e2d\u4fe1",
  ".\u9999\u683c\u91cc\u62c9",
  ".\u6de1\u9a6c\u9521",
  ".\u5927\u4f17\u6c7d\u8f66",
  ".verm\u00f6gensberater",
  ".verm\u00f6gensberatung",
  ".\u30b0\u30fc\u30b0\u30eb",
  ".\u8c37\u6b4c",
  ".\u5de5\u884c",
  ".\u5609\u91cc",
  ".\u5609\u91cc\u5927\u9152\u5e97",
  ".\u98de\u5229\u6d66",
  ".\u8bfa\u57fa\u4e9a",
  ".\u96fb\u8a0a\u76c8\u79d1",
  ".\uc0bc\uc131",
  ".example",
  ".invalid",
  ".local",
  ".localhost",
  ".onion",
  ".test",
  ".i2p",
  ".glue",
  ".\u6d4b\u8bd5",
  ".\u6e2c\u8a66",
  ".\u0438\u0441\u043f\u044b\u0442\u0430\u043d\u0438\u0435",
  ".\u092a\u0930\u0940\u0915\u094d\u0937\u093e",
  ".\u03b4\u03bf\u03ba\u03b9\u03bc\u03ae",
  ".\ud14c\uc2a4\ud2b8",
  ".\u30c6\u30b9\u30c8",
  ".\u0baa\u0bb0\u0bbf\u0b9f\u0bcd\u0b9a\u0bc8"
]